import { useFormik } from "formik";
import React, { useState } from "react";
import { Card, Col, Container, Image, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import pswimg from "../../assets/images/psw-flow1.svg";
import Navbar from "../../components/Navbar";
import Footer from "../../components/footerAccessibilityPageFooter";
import "../../styles/Forgetpsw.css";
import { auth } from "../../helpers/firebaseConfig";

const Mobilereg = () => {
  const navigate = useNavigate();

  const [confirmation, setConfirmation] = useState({ user: "kaviraj" });

  const formik = useFormik({
    initialValues: {
      mobilenumber: "",
    },
    validationSchema: Yup.object({
      mobilenumber: Yup.string()
        .required("Mobile number is required")
        .matches(/^[0-9]{10}$/, "Mobile number is not valid"),
    }),
    onSubmit: (values) => {
      // navigate('/mobile/otp',{state:{mobilenumber:values.mobilenumber}});
      sendOtp(values.mobilenumber);
    },
  });

  const sendOtp = async (mobileNumber) => {
    try {
      console.log("inside the sendOtp nested try");
      const confirmValue = { user: "gkraj" };
      setConfirmation(confirmValue);

      // Make sure the recaptcha element is available in the DOM before initializing
      const recaptchaElement = document.getElementById("recaptcha");
      if (!recaptchaElement) {
        throw new Error("reCAPTCHA element is not available in the DOM");
      }

      // Initialize reCAPTCHA
      window.recaptchaVerifier = new RecaptchaVerifier(auth, "recaptcha", {});
      const phone = "9345487805";
      const recaptcha = window.recaptchaVerifier;
      const phoneNumber = `${"+91" + mobileNumber}`;
      console.log("phone", phoneNumber);

      // Send OTP
      const confirmationResult = await signInWithPhoneNumber(
        auth,
        phoneNumber,
        recaptcha
      );
      console.log("confirmationResult", confirmationResult);
      window.confirmationResult = confirmationResult; // Store the confirmation result
      setConfirmation(confirmationResult);
      navigate("/mobile/otp", { state: { mobileNumber } });
    } catch (error) {
      console.error("Error sending OTP", error);
    }
  };

  return (
    <Container fluid className="p-0 pswd d-flex flex-column min-vh-100">
      <Navbar />
      <div className="flex-grow-1 d-flex justify-content-center align-items-center container p-0">
        <Row className="w-100 pswd-row d-flex justify-content-between align-items-center m-0">
          <Col md={6} lg={5}>
            <Card className="pswd-content">
              <h4 className="fw-bold">Enter Your Registered Mobile Number</h4>
              <p className="p-title">
                Enter the mobile number associated with your account
              </p>
              <form onSubmit={formik.handleSubmit}>
                <input
                  type="text"
                  placeholder="Enter your Mobile number"
                  id="mobilenumber"
                  name="mobilenumber"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.mobilenumber}
                  className={`form-control mt-3 mb-2 py-2 input-height ${
                    formik.touched.mobilenumber && formik.errors.mobilenumber
                      ? "is-invalid"
                      : ""
                  }`}
                />
                {formik.touched.mobilenumber && formik.errors.mobilenumber ? (
                  <div className="invalid-feedback">
                    {formik.errors.mobilenumber}
                  </div>
                ) : null}

                <button
                  type="submit"
                  className="btn btn-color-primary input-height w-100 py-2 mt-4 ms-0"
                >
                  <strong>Continue</strong>
                </button>
              </form>
              <div id="recaptcha" className="mt-4"></div>
            </Card>
          </Col>
          <Col md={5} className="d-none d-md-block">
            <Image className="pswd-img" src={pswimg} alt="img" fluid />
          </Col>
        </Row>
      </div>
      <Footer className="mt-auto" />
    </Container>
  );
};

export default Mobilereg;
